import React, { useEffect, useRef } from "react";
import { animate } from "animejs";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  source: string;
  alt: string;
}

const Image: React.FC<ImageProps> = ({ source, className, alt }) => {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imageRef.current) {
      animate(imageRef.current, {
        opacity: [0, 2],
        duration: 1000,
        ease: "inOut(6)",
      });
    }
  }, []);

  return <img ref={imageRef} className={className} alt={alt} src={source} />;
};

export default Image;
